module.exports = __webpack_public_path__ + "img/login3.bbf1acc7.png";